export default "__VITE_ASSET__F6ymwlzO__"